export const MAX_ALLOWED_MODULES = 3
export const MAX_SOLENOIDS = 6
export const LOCKED_MODULE_ID = '3' // ECP 3 solenoids cannot be moved
